import _sfc_main from './IdfTextIcon.vue2.mjs';
import '../../IdfTextIcon.vue_vue_type_style_index_0_scoped_1658f5f7_lang.css';import _export_sfc from '../../_virtual/_plugin-vue_export-helper.mjs';

const IdfTextIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-1658f5f7"]]);

export { IdfTextIcon as default };
